/**
 * `text` with `block` in place of the selection, as a paragraph of its own: a blank line
 * before and after it. `caret` follows the block.
 */
export function insertBlock(
  text: string,
  start: number,
  end: number,
  block: string,
): { text: string; caret: number } {
  const before = text.slice(0, start)
  const after = text.slice(end)
  const lead = before === '' || before.endsWith('\n\n') ? '' : before.endsWith('\n') ? '\n' : '\n\n'
  const trail = after.startsWith('\n\n')
    ? ''
    : after.startsWith('\n') || after === ''
      ? '\n'
      : '\n\n'
  const inserted = `${lead}${block}${trail}`
  return { text: before + inserted + after, caret: before.length + inserted.length }
}
